import { useDispatch } from 'react-redux';
import { setAlert } from '@store/alerts.reducer';

// success, error, info, warning
export const useAddAlert = () => {
	const d = useDispatch();
	return (data) => d(setAlert({ type: 'success', ...data }));
};
